export default __webpack_public_path__ + "static/media/upload.6076e53f.png";